<template lang="">
    <Modal
        :showModal="showModal"
        title="Check-in"
        @closeModal="onCloseModal"
    >
        <SearchableExpandableRadio
            title="Código Sold"
            placeholder="Selecione um Sold"
            class="max-w-[250px] full z-10"
            :options="storeOptions"
            :initialValue="form.store"
            @updateValue="form.store = $event"
        />
        <Button
            :disabled="!!!form.store?.id"
            @click="handlecurrentActivityChange"
            class="py-1"
            >Mudar localização</Button
        >

        <Modal
            :showModal="isNeedConfirmModalOpen"
            title="Confirmação"
            @closeModal="toggleIsNeedConfirmModalOpen"
        >
            <p class="mt-2.5">
                A Sub-regional selecionada é diferente da configurada no
                itinerário, deseja fazer check-in mesmo assim?
            </p>
            <div class="flex gap-x-8 justify-center mt-5">
                <button
                    class="px-4 py-2 bg-white border border-primary rounded-full font-bold text-primary hover:bg-gray-300 hover:border-gray-300"
                    @click="closeNeedConfirmModal()"
                >
                    Cancelar
                </button>
                <button
                    class="px-4 py-2 bg-primary rounded-2xl font-bold text-white hover:bg-highlight"
                    :class="
                        disableButton
                            ? 'bg-blue-100 cursor-not-allowed pointer-events-none'
                            : ''
                    "
                    @click.prevent="currentActivityChange"
                >
                    Sim, enviar
                </button>
            </div>
        </Modal>
    </Modal>
</template>
<script>

import Button from '@/Components/Button.vue'
import Modal from "@/Components/UI/Modals/Modal.vue";
import SearchableExpandableRadio from "@/Components/SearchableExpandableRadio.vue";
import axios from "axios";

export default {
    components: {
        Button,
        Modal,
        SearchableExpandableRadio,
    },

    props: {
        showModal: Object,
        currentRegion: Object,
    },

    data() {
        return {
            isChangeModalOpen: false,
            isNeedConfirmModalOpen: false,
            form: {
                store: ''
            },
            stores: [],
            loading: false,
        }
    },

    emits: ["closeModal"],

    async mounted() {
        const { data } = await axios.get(this.route('api.participants.get-stores'));
        this.stores = data?.items ?? [];

        await this.loadCurrentActivity();
    },

    methods: {
        onCloseModal() {
            this.$emit("closeModal");
        },
        closeChangeModal() {
            this.onCloseModal();
        },
        closeNeedConfirmModal() {
            this.isNeedConfirmModalOpen = false;
        },
        toggleIsNeedConfirmModalOpen() {
            this.isNeedConfirmModalOpen = !this.isNeedConfirmModalOpen;
        },
        handlecurrentActivityChange() {
            if (this.currentRegion?.subregionId === this.form.store.subregionId)
                this.currentActivityChange();
            else
                this.toggleIsNeedConfirmModalOpen();
        },
        currentActivityChange() {
            this.closeNeedConfirmModal();
            if (!!!this.loading) {
                this.loading = true;
                axios.post(this.route('api.participants.force-activity-create'), {
                    pdvId: this.form.store.id,
                    subregionId: this.form.store.subregionId,
                    regionId: this.form.store.regionId,
                }).then(({data}) => {
                    this.loadCurrentActivity();
                    this.closeChangeModal();
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        async loadCurrentActivity() {
            const { data } = await axios.get(this.route('api.participants.get-current-activity'));

            if (data.data) {
                const currentActivity = data.data;
                this.$page.props.auth.user.participant.currentActivity = currentActivity;
                this.selectStoreOption(currentActivity);
            }
        },
        selectStoreOption(currentActivity) {
            this.form.store = this.storeOptions.find((store) => store.id === currentActivity?.pdv?.id);
        }
    },

    computed: {
        currentActivity() {
            return this.$page.props.auth.user.participant.currentActivity;
        },
        storeOptions() {
            return this.stores.map(
                ({
                    id,
                    codeSoldBroker,
                    regionId,
                    subregionId,
                    subRegion,
                    name,
                }) => ({
                    id,
                    name: `${codeSoldBroker} ${name} ${subRegion}`,
                    regionId,
                    subregionId,
                })
            );
        },
    }
}
</script>
